<nz-skeleton [nzParagraph]="{ rows: 4 }" [nzActive]="true"></nz-skeleton>
<nz-skeleton [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>